import { sendToApi } from 'api/client'
import { KnowledgeBaseSnippet, KnowledgeBaseSourceMaterial } from 'types'

export interface CreateKnowledgeBaseSnippetPayload extends Omit<KnowledgeBaseSnippet, 'id' | 'updated_at' | 'owner'> {}

export interface CreateKnowledgeBaseSourceMaterialPayload
  extends Omit<
    KnowledgeBaseSourceMaterial,
    | 'id'
    | 'updated_at'
    | 'owner'
    | 'use_count'
    | 'kind'
    | 'created_at'
    | 'source_url'
    | 'source_article'
    | 'source_file_filename'
    | 'source_file_url'
  > {
  source_article?: string | null
  source_file?: File | null
  source_url?: KnowledgeBaseSourceMaterial['source_url'] | null
}

export interface UpdateKnowledgeBaseSourceMaterialPayload extends CreateKnowledgeBaseSourceMaterialPayload {
  id: number
}

export const KnowledgeBaseClient = {
  createSnippet: (snippetData: CreateKnowledgeBaseSnippetPayload) =>
    sendToApi(`/knowledge_base/snippets`, {
      method: 'POST',
      body: snippetData,
    }),
  createSourceMaterial: (sourceMaterialsData: CreateKnowledgeBaseSourceMaterialPayload) => {
    const formData = new FormData()
    for (const key in sourceMaterialsData) {
      const value = sourceMaterialsData[key as keyof typeof sourceMaterialsData]
      if (!value) continue

      formData.append(key, value)
    }

    return sendToApi<KnowledgeBaseSourceMaterial>(`/knowledge_base/source_materials`, {
      method: 'POST',
      body: formData,
    })
  },
  updateSnippet: (snippet: KnowledgeBaseSnippet) =>
    sendToApi(`/knowledge_base/snippets/${snippet.id}`, {
      method: 'PUT',
      body: snippet,
    }),
  updateSourceMaterial: ({ id, ...sourceMaterial }: UpdateKnowledgeBaseSourceMaterialPayload) => {
    const formData = new FormData()
    for (const key in sourceMaterial) {
      const value = sourceMaterial[key as keyof typeof sourceMaterial]
      if (!value) continue

      formData.append(key, value)
    }

    return sendToApi<KnowledgeBaseSourceMaterial>(`/knowledge_base/source_materials/${id}`, {
      method: 'PUT',
      body: formData,
    })
  },
  deleteSnippet: (snippet: KnowledgeBaseSnippet) =>
    sendToApi(`/knowledge_base/snippets/${snippet.id}`, {
      method: 'DELETE',
    }),
  deleteSourceMaterial: (sourceMaterialId: KnowledgeBaseSourceMaterial['id']) =>
    sendToApi(`/knowledge_base/source_materials/${sourceMaterialId}`, {
      method: 'DELETE',
    }),
  incrementUse: (snippet: KnowledgeBaseSnippet) =>
    sendToApi(`/knowledge_base/snippets/${snippet.id}/use`, {
      method: 'PUT',
    }),
  getSnippets: () => sendToApi<{ knowledge_base_snippets: KnowledgeBaseSnippet[] }>('/knowledge_base/snippets'),
  getSourceMaterials: () =>
    sendToApi<{ knowledge_base_source_materials: KnowledgeBaseSourceMaterial[] }>('/knowledge_base/source_materials'),
}
